import { Layout } from "@/components/layout/index.tsx";
import DefaultPendingComponent from "@/components/page-loading.tsx";
import { Button } from "@/components/ui/button.tsx";
import { env } from "@/env";
import { authStore, getUser } from "@/lib/auth/store.tsx";
import { localizeHref, setLocale } from "@/paraglide/runtime.js";
import type { QueryClient } from "@tanstack/react-query";
import {
	createRootRouteWithContext,
	redirect,
	stripSearchParams,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useMemo } from "react";
import TanStackQueryLayout from "../integrations/tanstack-query/layout.tsx";

// console.log("auto deploy 1");

interface MyRouterContext {
	queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<Layout />
			{/* <TanStackRouterDevtools /> */}
			{/* <TanStackQueryLayout /> */}
		</>
	),
	validateSearch: (
		search: Record<string, unknown>,
	): {
		inviteCode?: string;
	} => {
		return {
			inviteCode: search?.inviteCode as string,
		};
	},
	search: {
		middlewares: [
			({ search, next }) => {
				if (search.inviteCode) {
					localStorage.setItem("INVITE_CODE", search.inviteCode as string);
				}
				return next(search);
			},
			stripSearchParams(["inviteCode"]),
		],
	},
	wrapInSuspense: true,
	beforeLoad: async ({ matches, location }) => {
		/**
		 * 特殊的fix
		 */
		//
		if (import.meta.env.PROD && location.pathname.split("/").includes("zh")) {
			setLocale("en", { reload: false });
			window.location.href = "/en";
			return;
		}
		const authToken = localStorage.getItem("AUTH_TOKEN");
		if (authToken && !authStore.state.user) {
			const isHome = matches?.at(-1)?.routeId === "/$lang/";
			if (isHome) {
				getUser(); //首页不阻塞路由加载
			} else {
				await getUser();
			}
		}
	},
	pendingComponent: DefaultPendingComponent,
	errorComponent: GlobalErrorBoundary,
});

function GlobalErrorBoundary({ error }: { error: Error }) {
	const errorMessage = useMemo(() => {
		if (error.stack) {
			try {
				const stackLines = error.stack?.split("\n");
				return stackLines?.slice(0, 2).join("\n");
			} catch (e) {
				return error.toString();
			}
		}
		return error.toString();
	}, [error]);

	return (
		<div className="flex items-center justify-center min-h-screen p-8">
			<div className="p-8 rounded-lg border border-line1 text-center sm:max-w-1/2 lg:max-w-1/3 w-full">
				<h2 className="text-2xl font-bold mb-4 text-main1">
					Oops! Something went wrong.
				</h2>
				<p className="text-t3 mb-4 w-full">{errorMessage}</p>
				<Button
					onClick={() => {
						const token = localStorage.getItem("AUTH_TOKEN");
						localStorage.clear();
						sessionStorage.clear();
						window.localStorage.setItem("IS_ADULT_CHECKED", "true");
						if (token) {
							window.localStorage.setItem("AUTH_TOKEN", token || "");
						}
						window.location.href = localizeHref("/");
					}}
				>
					Clear Cache & Go Home
				</Button>
			</div>
		</div>
	);
}
